import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { postAPI, reinitialiseAPI } from 'store/apiReducer';
import { connect } from 'react-redux';
import {
    ButtonGroup,
    Button,
    SelectControl,
    SegmentLoader,
    Row,
    Col,
    InputControl,
} from '@design-system-etat/dsfr-react';
import { useForm, FormProvider } from 'react-hook-form';
import moment from 'moment';
import InputFiles from 'components/Commun/Form/InputFiles';
import FileUploadeAbstract from 'components/Commun/Form/InputFiles/Model/FileUploadeAbstract';
import { getDateFormatWithSlash } from 'components/Commun/Form/maskFunctions';
import SelectDepartements from 'components/form/referentiel/select/SelectDepartement';
import SelectPays from 'components/form/referentiel/select/SelectPays';
import SelectCommune from 'components/form/referentiel/select/SelectCommune';
import usagerClientReducer from 'store/usagerReducer';
import {
    API_COMPTE_CREER_IDENTITE_URL,
    API_ENREGISTRER_PERMIS_DE_CHASSE_CREER_COMPTE_DETENTEUR_E_1_IDENTITE_URL,
    API_ENREGISTRER_PIECE_IDENTITE_CREER_COMPTE_DETENTEUR_E_1_IDENTITE_V2_URL,
    API_ENREGISTRER_VALIDATION_PERMIS_CHASSER_CREER_COMPTE_DETENTEUR_E_1_IDENTITE_URL,
    API_ENREGISTRER_VERSO_LICENCE_CREER_COMPTE_DETENTEUR_E_1_IDENTITE_URL,
    CONTEXT_CREER_COMPTE_ETAPE_IDENTITE,
    CONTEXT_ENREGISTRER_PERMIS_DE_CHASSE_CREER_COMPTE_DETENTEUR_E_1_IDENTITE,
    CONTEXT_ENREGISTRER_PIECE_IDENTITE_CREER_COMPTE_DETENTEUR_E_1_IDENTITE_V2,
    CONTEXT_ENREGISTRER_VALIDATION_PERMIS_CHASSER_CREER_COMPTE_DETENTEUR_E_1_IDENTITE,
    CONTEXT_ENREGISTRER_VERSO_LICENCE_BALLTRAP_CREER_COMPTE_DETENTEUR_E_1_IDENTITE,
    CONTEXT_ENREGISTRER_VERSO_LICENCE_SKI_CREER_COMPTE_DETENTEUR_E_1_IDENTITE,
} from 'constants/apiUrls.constants';
import {
    REGEXP_DATE_AVEC_MOIS_JOUR_INCONNU,
    REGEXP_DATE_AVEC_ANNEE,
    REGEXP_NOM_PRENOM,
} from 'constants/contraintes.constants';
import {
    formaterOptions,
    getMessageErreurChampManquant,
    getPatternHookFormValidation,
} from 'utils/utils';
import { MESSAGE_DATE_INVALIDE } from 'constants/messagePersonalise.constants';
import useToaster from 'hooks/useToaster';
import {
    FEATURE_APPEL_API_FFBT,
    FEATURE_APPEL_API_FFTIR,
    isFeatureActive,
} from 'components/FeatureFlipping/featureFlipping.func';
import formaterCreationIdentite from './FormaterCreationIdentite';
import InformationChasseur from './licence/InformationChasseur';
import InformationLicencie from './licence/InformationLicencie';
import formaterFichiersPiecesIdentiteEtape1 from './FormaterFichiersPiecesIdentiteEtape1';
import formaterFichierPermisDeChasse from './FormaterFichierPermisDeChasse';
import formaterFichierValidationPermisChasser from './FormaterFichierValidationPermisChasser';
import formaterFichierVersoLicenceSki from './FormaterFichierVersoLicenceSki';
import formaterFichierVersoLicenceBallTrap from './FormaterFichierVersoLicenceBallTrap';
import formaterFichierVersoLicenceTir from './FormaterFichierVersoLicenceTir';
import InfoChampsObligatoire from '../../../../../../components/form/infoObligatoire/InfoChampsObligatoire';

// @todo Refacto le composant (Utiliser le validator de ReactHookForm, éviter les setValue, trigger
const CreerCompteIdentite = ({
    dataIdentiteRenseignee,
    setEtapeIdentite,
    setAncienLicencie,
    postApi,
    isLoading,
    retourEtape,
    erreur,
    message,
    data,
    uuidBrouillon,
    motifs,
    reinitialiseApi,
    isLoadingRenseignerPiecesIdentite,
    erreurRenseignerPiecesIdentite,
    dataRenseignerPiecesIdentite,
    isLoadingPermisDeChasse,
    erreurPermisDeChasse,
    dataRenseignerPermisDeChasse,
    isLoadingValidationPermisChasser,
    erreurValidationPermisChasser,
    dataRenseignerValidationPermisChasser,
    isLoadingVersoLicenceSki,
    erreurVersoLicenceSki,
    dataRenseignerVersoLicenceSki,
    isLoadingVersoLicenceBallTrap,
    erreurVersoLicenceBallTrap,
    dataRenseignerVersoLicenceBallTrap,
    isLoadingVersoLicenceTir,
    erreurVersoLicenceTir,
    dataRenseignerVersoLicenceTir,
    featureFlipping,
}) => {
    const hookForm = useForm({
        mode: 'onChange',
        defaultValues: {
            paysNaissance: '75',
            ...dataIdentiteRenseignee,
        },
    });

    const { register, handleSubmit, getValues, watch, formState, trigger, setValue } = hookForm;
    const [dataIdentite, setDataIdentite] = useState();

    // SelectCommune params
    const [valueRecherche, setValueRecherche] = useState(getValues('lieuNaissance') ?? '');

    const choixSexe = [
        { key: 'F', value: '2', libelle: 'Féminin' },
        { key: 'M', value: '1', libelle: 'Masculin' },
    ];

    const typePieceIdentite = [
        { key: 'CNI', value: 2, libelle: "Carte nationale d'identité" },
        { key: 'passeport', value: 33, libelle: 'Passeport' },
        { key: 'titreSejour', value: 34, libelle: 'Titre de séjour' },
        { key: 'pieceIdentiteEtrangere', value: 35, libelle: 'Pièce identité étrangère' },
    ];

    const { triggerToaster, closeToaster } = useToaster();

    useEffect(() => {
        if (dataIdentiteRenseignee) {
            setValue('piecesIdentite', dataIdentiteRenseignee.piecesIdentite);
            setValue('versoLicenceSki', dataIdentiteRenseignee.versoLicenceSki);
            setValue('versoLicenceBallTrap', dataIdentiteRenseignee.versoLicenceBallTrap);
            setValue('numeroGuichetUnique', dataIdentiteRenseignee.numeroGuichetUnique);
            setValue('permisDeChasse', dataIdentiteRenseignee.permisDeChasse);
            setValue('validationPermisChasser', dataIdentiteRenseignee.validationPermisChasser);
            setValue(
                'selectLicencieOrAncienLicencieTir',
                dataIdentiteRenseignee.selectLicencieOrAncienLicencieTir,
            );
            setValue(
                'selectLicencieOrAncienLicencieSki',
                dataIdentiteRenseignee.selectLicencieOrAncienLicencieSki,
            );
            setValue(
                'selectLicencieOrAncienLicencieBallTrap',
                dataIdentiteRenseignee.selectLicencieOrAncienLicencieBallTrap,
            );
        }
    }, []);

    async function postPiecesIdentite() {
        (await formaterFichiersPiecesIdentiteEtape1(dataIdentite)).forEach((value, index) => {
            postApi(
                usagerClientReducer,
                API_ENREGISTRER_PIECE_IDENTITE_CREER_COMPTE_DETENTEUR_E_1_IDENTITE_V2_URL.replace(
                    '{index}',
                    index + 1,
                ),
                {
                    pieceIdentite: value,
                    key: index + 1,
                    uuidBrouillon,
                },
                CONTEXT_ENREGISTRER_PIECE_IDENTITE_CREER_COMPTE_DETENTEUR_E_1_IDENTITE_V2,
            );
        });
    }
    async function postPermisDeChasse() {
        await postApi(
            usagerClientReducer,
            API_ENREGISTRER_PERMIS_DE_CHASSE_CREER_COMPTE_DETENTEUR_E_1_IDENTITE_URL,
            {
                permisDeChasse: await formaterFichierPermisDeChasse(dataIdentite),
                uuidBrouillon,
            },
            CONTEXT_ENREGISTRER_PERMIS_DE_CHASSE_CREER_COMPTE_DETENTEUR_E_1_IDENTITE,
        );
    }
    async function postValidationPermisChasser() {
        await postApi(
            usagerClientReducer,
            API_ENREGISTRER_VALIDATION_PERMIS_CHASSER_CREER_COMPTE_DETENTEUR_E_1_IDENTITE_URL,
            {
                validationPermisChasser: await formaterFichierValidationPermisChasser(dataIdentite),
                uuidBrouillon,
            },
            CONTEXT_ENREGISTRER_VALIDATION_PERMIS_CHASSER_CREER_COMPTE_DETENTEUR_E_1_IDENTITE,
        );
    }

    async function postVersoLicenceSki() {
        await postApi(
            usagerClientReducer,
            API_ENREGISTRER_VERSO_LICENCE_CREER_COMPTE_DETENTEUR_E_1_IDENTITE_URL,
            {
                versoLicence: await formaterFichierVersoLicenceSki(dataIdentite),
                uuidBrouillon,
                typeLicence: 'licenceDeSki',
            },
            CONTEXT_ENREGISTRER_VERSO_LICENCE_SKI_CREER_COMPTE_DETENTEUR_E_1_IDENTITE,
        );
    }

    async function postVersoLicenceBallTrap() {
        await postApi(
            usagerClientReducer,
            API_ENREGISTRER_VERSO_LICENCE_CREER_COMPTE_DETENTEUR_E_1_IDENTITE_URL,
            {
                versoLicence: await formaterFichierVersoLicenceBallTrap(dataIdentite),
                uuidBrouillon,
                typeLicence: 'licenceBallTrap',
            },
            CONTEXT_ENREGISTRER_VERSO_LICENCE_BALLTRAP_CREER_COMPTE_DETENTEUR_E_1_IDENTITE,
        );
    }

    async function postVersoLicenceTir() {
        await postApi(
            usagerClientReducer,
            API_ENREGISTRER_VERSO_LICENCE_CREER_COMPTE_DETENTEUR_E_1_IDENTITE_URL,
            {
                versoLicence: await formaterFichierVersoLicenceTir(dataIdentite),
                uuidBrouillon,
                typeLicence: 'licenceDeTir',
            },
            CONTEXT_ENREGISTRER_VERSO_LICENCE_BALLTRAP_CREER_COMPTE_DETENTEUR_E_1_IDENTITE,
        );
    }

    function conditionPourPasserEtapeSuivante() {
        const informationsIdentiteEnvoyee = isLoading === false && data && !erreur;

        const piecesIdentiteEnvoyee =
            !isLoadingRenseignerPiecesIdentite &&
            dataRenseignerPiecesIdentite &&
            !erreurRenseignerPiecesIdentite;

        const permisDeChasseEnvoyee =
            !isLoadingPermisDeChasse && dataRenseignerPermisDeChasse && !erreurPermisDeChasse;

        const validationPermisChasserEnvoyee =
            !isLoadingValidationPermisChasser &&
            dataRenseignerValidationPermisChasser &&
            !erreurValidationPermisChasser;

        const versoLicenceSkiEnvoyee =
            isLoadingVersoLicenceSki === false &&
            dataRenseignerVersoLicenceSki &&
            !erreurVersoLicenceSki;
        const versoLicenceBallTrapEnvoyee =
            isLoadingVersoLicenceBallTrap === false &&
            dataRenseignerVersoLicenceBallTrap &&
            !erreurVersoLicenceBallTrap;
        const versoLicenceTirEnvoyee =
            isLoadingVersoLicenceTir === false &&
            dataRenseignerVersoLicenceTir &&
            !erreurVersoLicenceTir;

        return (
            piecesIdentiteEnvoyee &&
            informationsIdentiteEnvoyee &&
            ((motifs && motifs.isChasseur && permisDeChasseEnvoyee) ||
                validationPermisChasserEnvoyee ||
                (motifs &&
                    motifs.isLicencie &&
                    ((dataIdentite && dataIdentite.numeroLicenceTir) ||
                        versoLicenceSkiEnvoyee ||
                        versoLicenceBallTrapEnvoyee ||
                        versoLicenceTirEnvoyee ||
                        ((watch('selectLicencieOrAncienLicencieTir') === 'isAncienLicencie' ||
                            !watch('selectLicencieOrAncienLicencieTir')) &&
                            (watch('selectLicencieOrAncienLicencieBallTrap') ===
                                'isAncienLicencie' ||
                                !watch('selectLicencieOrAncienLicencieBallTrap')) &&
                            (watch('selectLicencieOrAncienLicencieSki') === 'isAncienLicencie' ||
                                !watch('selectLicencieOrAncienLicencieSki'))))) ||
                (motifs && motifs.isNonLicencie))
        );
    }

    useEffect(() => {
        if (conditionPourPasserEtapeSuivante()) {
            setEtapeIdentite(dataIdentite);

            const unAncienLicencie =
                getValues('selectLicencieOrAncienLicencieTir') === 'isAncienLicencie' ||
                !getValues('selectLicencieOrAncienLicencieTir') ||
                getValues('selectLicencieOrAncienLicencieBallTrap') === 'isAncienLicencie' ||
                !getValues('selectLicencieOrAncienLicencieBallTrap') ||
                getValues('selectLicencieOrAncienLicencieSki') === 'isAncienLicencie' ||
                !getValues('selectLicencieOrAncienLicencieSki');

            setAncienLicencie(unAncienLicencie);
        }
    }, [
        isLoading,
        data,
        erreur,
        isLoadingRenseignerPiecesIdentite,
        dataRenseignerPiecesIdentite,
        erreurRenseignerPiecesIdentite,
        isLoadingPermisDeChasse,
        dataRenseignerPermisDeChasse,
        erreurPermisDeChasse,
        isLoadingValidationPermisChasser,
        dataRenseignerValidationPermisChasser,
        erreurValidationPermisChasser,
        isLoadingVersoLicenceSki,
        dataRenseignerVersoLicenceSki,
        erreurVersoLicenceSki,
        isLoadingVersoLicenceBallTrap,
        dataRenseignerVersoLicenceBallTrap,
        erreurVersoLicenceBallTrap,
    ]);

    // on mount et unmount
    useEffect(() => {
        window.scrollTo(0, 0);
        reinitialiseApi(CONTEXT_CREER_COMPTE_ETAPE_IDENTITE);
        return () => {
            reinitialiseApi(CONTEXT_CREER_COMPTE_ETAPE_IDENTITE);
        };
    }, []);

    // --------- GESTION DES ERREURS DE CHAMPS --------------

    // Revalider les champs prénoms quand un prénom est modifié.
    useEffect(() => {
        trigger(['prenomDeux', 'prenomTrois', 'prenomQuatre', 'prenomUsuel']);
    }, [
        watch('prenomUn'),
        watch('prenomDeux'),
        watch('prenomTrois'),
        watch('prenomQuatre'),
        watch('prenomUsuel'),
    ]);

    // Revalider le departement de Naissance
    useEffect(() => {
        trigger(['paysNaissance', 'departementNaissance']);
    }, [watch('paysNaissance'), watch('departementNaissance')]);

    const validatePrenomUsuel = (valuePrenomUsuel) => {
        if (
            valuePrenomUsuel &&
            valuePrenomUsuel !== getValues('prenomUn') &&
            valuePrenomUsuel !== getValues('prenomDeux') &&
            valuePrenomUsuel !== getValues('prenomTrois') &&
            valuePrenomUsuel !== getValues('prenomQuatre')
        ) {
            return 'Le prénom usuel doit correspondre à un des autres prénoms';
        }
        return null;
    };

    const validateDate = (dateValue) => {
        const dateSplit = dateValue.split('/');
        const dateExistante = new Date(dateSplit[2], dateSplit[1] - 1, dateSplit[0]);
        if (
            (dateSplit &&
                moment(`${dateSplit[2]}-${dateSplit[1]}-${dateSplit[0]}`).diff(moment()) > 0) ||
            (dateSplit[1] !== '00' &&
                dateSplit[0] !== '00' &&
                (dateExistante.getFullYear() !== parseInt(dateSplit[2], 10) ||
                    dateExistante.getMonth() + 1 !== parseInt(dateSplit[1], 10) ||
                    dateExistante.getDate() !== parseInt(dateSplit[0], 10)))
        ) {
            return MESSAGE_DATE_INVALIDE;
        }
        return null;
    };

    const validateMajorite = (valueDateNaissance) => {
        if (valueDateNaissance.length === 10) {
            const ageMajorite = 18;
            const dateNaissanceSplit = valueDateNaissance.split('/');
            const today = new Date();
            const thisYear = today.getFullYear();
            const birthDay = dateNaissanceSplit[0];
            const birthMonth = dateNaissanceSplit[1];
            const birthYear = dateNaissanceSplit[2];
            const valideAge = new RegExp(REGEXP_DATE_AVEC_ANNEE);

            if (valideAge.test(birthYear)) {
                if (
                    ((birthDay === '00' || birthMonth === '00') &&
                        birthYear > thisYear - ageMajorite) ||
                    moment().diff(moment(birthYear + birthMonth + birthDay, 'YYYYMMDD'), 'years') <
                        ageMajorite
                ) {
                    return "L'Espace Détenteurs n'est pas encore ouvert aux détenteurs mineurs.";
                }
            }
        }

        return null;
    };

    const validateDepartement = (valueDepartement) => {
        if (!valueDepartement && getValues('paysNaissance') === '75') {
            return getMessageErreurChampManquant('département de Naissance');
        }

        /**
         * Passe la valeur du champ département à "null" si on sélectionne un autre pays que la France alors
         * qu'on a choisi le département avant.
         */
        if (getValues('paysNaissance') !== '75') {
            setValue('departementNaissance', null);
        }

        return null;
    };

    // --------- GESTION DE LA VALIDATION ET ENVOI DU FORMULAIRE --------------
    // A REFACTO => Utiliser react hook form
    const hasFormValid = () => {
        let formulaireEstValide = formState.isValid;

        // verification de la pièce d'identité;
        formulaireEstValide =
            formulaireEstValide &&
            getValues('piecesIdentite') &&
            getValues('piecesIdentite').length > 0;
        // verification des pj chasseur
        if (motifs && motifs.isChasseur) {
            formulaireEstValide =
                formulaireEstValide &&
                watch('numeroPermisChasseur') &&
                getValues('permisDeChasse') &&
                getValues('permisDeChasse').length > 0;

            if (getValues('numeroGuichetUnique')) {
                formulaireEstValide =
                    formulaireEstValide &&
                    getValues('numeroGuichetUnique') &&
                    getValues('validationPermisChasser') &&
                    getValues('validationPermisChasser').length > 0;
            }
        }
        // vérification Licence

        if (motifs && motifs.isLicencie) {
            // au moins une licence
            formulaireEstValide =
                formulaireEstValide &&
                (watch('selectLicencieOrAncienLicencieTir') ||
                    watch('selectLicencieOrAncienLicencieBallTrap') ||
                    watch('selectLicencieOrAncienLicencieSki'));

            if (watch('selectLicencieOrAncienLicencieTir') === 'isLicencie') {
                formulaireEstValide = formulaireEstValide && watch('numeroLicenceTir');
            }
            if (watch('selectLicencieOrAncienLicencieSki') === 'isLicencie') {
                formulaireEstValide =
                    formulaireEstValide &&
                    watch('numeroLicenceSki') &&
                    watch('versoLicenceSki') &&
                    watch('versoLicenceSki').length > 0;
            }
            if (watch('selectLicencieOrAncienLicencieBallTrap') === 'isLicencie') {
                formulaireEstValide =
                    formulaireEstValide &&
                    watch('numeroLicenceBallTrap') &&
                    watch('versoLicenceBallTrap') &&
                    watch('versoLicenceBallTrap').length > 0;
            }
        }
        return formulaireEstValide;
    };

    useEffect(() => {
        const envoyerRequetes = async () => {
            // Appels successifs et controlés pour éviter un chevauchement
            // du header provoquant une 403 liée au CSRF cookie
            if (dataIdentite?.piecesIdentite) {
                await postPiecesIdentite();
            }

            if (dataIdentite?.permisDeChasse) {
                await postPermisDeChasse();
            }

            if (dataIdentite?.validationPermisChasser) {
                await postValidationPermisChasser();
            }

            if (dataIdentite?.versoLicenceSki) {
                await postVersoLicenceSki();
            }

            if (dataIdentite?.versoLicenceBallTrap) {
                await postVersoLicenceBallTrap();
            }

            if (dataIdentite?.versoLicenceTir) {
                await postVersoLicenceTir();
            }
        };

        if (!isLoading && data && !erreur) {
            envoyerRequetes();
        }
    }, [isLoading, data, erreur, dataIdentite]);

    const onSubmit = async (dataForm) => {
        window.scrollTo(0, 0); // Remonte la page en haut

        setDataIdentite(dataForm);

        const dataFormat = await formaterCreationIdentite(dataForm, uuidBrouillon);

        // Envoi principal du formulaire
        await postApi(
            usagerClientReducer,
            API_COMPTE_CREER_IDENTITE_URL,
            dataFormat,
            CONTEXT_CREER_COMPTE_ETAPE_IDENTITE,
        );
    };

    const renderMessage = (msg) => {
        return msg.split('\n').map((line) => <p key={line}>{line}</p>);
    };

    useEffect(() => {
        if (isLoading) {
            // Vérification des licences et génération du message approprié
            if (
                (isFeatureActive(featureFlipping, FEATURE_APPEL_API_FFTIR) &&
                    getValues('numeroLicenceTir') &&
                    getValues('selectLicencieOrAncienLicencieTir') === 'isLicencie') ||
                (isFeatureActive(featureFlipping, FEATURE_APPEL_API_FFBT) &&
                    getValues('numeroLicenceBallTrap') &&
                    getValues('selectLicencieOrAncienLicencieBallTrap') === 'isLicencie')
            ) {
                triggerToaster();
            }
        } else {
            closeToaster();
        }
    }, [isLoading, featureFlipping]);

    return (
        <SegmentLoader
            isLoading={
                isLoading ||
                isLoadingRenseignerPiecesIdentite ||
                isLoadingPermisDeChasse ||
                isLoadingValidationPermisChasser ||
                isLoadingVersoLicenceSki ||
                isLoadingVersoLicenceBallTrap
            }
        >
            {erreur && message && (
                <Row>
                    <Col col={12}>
                        <div className="fr-error">{renderMessage(message)}</div>
                    </Col>
                </Row>
            )}
            <FormProvider {...hookForm}>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <Row>
                        <Col col={12}>
                            <InfoChampsObligatoire />
                        </Col>
                    </Row>
                    {motifs && motifs.isChasseur && <InformationChasseur />}
                    {motifs && motifs.isLicencie && (
                        <InformationLicencie featureFlipping={featureFlipping} />
                    )}
                    <Row className="margin-top-lg">
                        <Col col={12}>
                            <h3>Identité</h3>
                        </Col>
                    </Row>
                    <Row gutters verticalAlign="bottom">
                        <Col col={12} lg={6}>
                            <SelectControl
                                id="sexe"
                                name="Sexe *"
                                label="Sexe *"
                                options={formaterOptions(choixSexe)}
                                required
                                state={formState.errors?.sexe ? 'error' : null}
                                message={formState.errors?.sexe?.message}
                                {...register('sexe', {
                                    required: getMessageErreurChampManquant('sexe'),
                                })}
                                placeholder="-- Choisir une option --"
                            />
                        </Col>
                        <Col col={12} lg={6}>
                            <InputControl
                                autocomplete="family-name"
                                id="nom"
                                label="Nom *"
                                required
                                uppercase
                                {...register('nom', {
                                    required: getMessageErreurChampManquant('nom'),
                                    pattern: getPatternHookFormValidation(REGEXP_NOM_PRENOM, 'nom'),
                                })}
                                state={formState.errors?.nom ? 'error' : null}
                                message={formState.errors?.nom?.message}
                            />
                        </Col>
                    </Row>
                    <Row gutters verticalAlign="bottom">
                        <Col col={12} lg={6}>
                            <InputControl
                                autocomplete="family-name"
                                id="nomUsage"
                                label="Nom d'usage"
                                hintText="Nom de famille utilisé dans la vie courante, à renseigner s'il ne s'agit pas du nom de naissance."
                                uppercase
                                {...register('nomUsage', {
                                    pattern: getPatternHookFormValidation(
                                        REGEXP_NOM_PRENOM,
                                        "nom d'usage",
                                    ),
                                })}
                                state={formState.errors?.nomUsage ? 'error' : null}
                                message={formState.errors?.nomUsage?.message}
                            />
                        </Col>
                        <Col col={12} lg={6}>
                            <InputControl
                                autocomplete="given-name"
                                id="prenomUn"
                                label="Premier prénom *"
                                required
                                uppercase
                                {...register('prenomUn', {
                                    required: getMessageErreurChampManquant('premier prénom'),
                                    pattern: getPatternHookFormValidation(
                                        REGEXP_NOM_PRENOM,
                                        'premier prénom',
                                    ),
                                })}
                                state={formState.errors?.prenomUn ? 'error' : null}
                                message={formState.errors?.prenomUn?.message}
                            />
                        </Col>
                    </Row>
                    <Row gutters verticalAlign="bottom">
                        <Col col={12} lg={6}>
                            <InputControl
                                autocomplete="additional-name"
                                id="prenomDeux"
                                label="Deuxième prénom"
                                disabled={!getValues('prenomUn')}
                                {...register('prenomDeux', {
                                    pattern: getPatternHookFormValidation(
                                        REGEXP_NOM_PRENOM,
                                        'deuxième prénom',
                                    ),
                                })}
                                uppercase
                                state={formState.errors?.prenomDeux ? 'error' : null}
                                message={formState.errors?.prenomDeux?.message}
                            />
                        </Col>
                        <Col col={12} lg={6}>
                            <InputControl
                                autocomplete="additional-name"
                                id="prenomTrois"
                                label="Troisième prénom"
                                disabled={!getValues('prenomUn') || !getValues('prenomDeux')}
                                {...register('prenomTrois', {
                                    pattern: getPatternHookFormValidation(
                                        REGEXP_NOM_PRENOM,
                                        'troisième prénom',
                                    ),
                                })}
                                uppercase
                                state={formState.errors?.prenomTrois ? 'error' : null}
                                message={formState.errors?.prenomTrois?.message}
                            />
                        </Col>
                    </Row>
                    <Row gutters verticalAlign="bottom">
                        <Col col={12} lg={6}>
                            <InputControl
                                autocomplete="additional-name"
                                id="prenomQuatre"
                                label="Quatrième prénom"
                                disabled={
                                    !getValues('prenomUn') ||
                                    !getValues('prenomDeux') ||
                                    !getValues('prenomTrois')
                                }
                                {...register('prenomQuatre', {
                                    pattern: getPatternHookFormValidation(
                                        REGEXP_NOM_PRENOM,
                                        'quatrième prénom',
                                    ),
                                })}
                                uppercase
                                state={formState.errors?.prenomQuatre ? 'error' : null}
                                message={formState.errors?.prenomQuatre?.message}
                            />
                        </Col>
                        <Col col={12} lg={6}>
                            <InputControl
                                autocomplete="given-name"
                                id="prenomUsuel"
                                label="Prénom usuel"
                                hintText="Prénom utilisé dans la vie courante, il doit être identique à l'un des prénoms renseignés dans le formulaire."
                                {...register('prenomUsuel', {
                                    pattern: getPatternHookFormValidation(
                                        REGEXP_NOM_PRENOM,
                                        'prénom usuel',
                                    ),
                                    validate: (value) => validatePrenomUsuel(value),
                                })}
                                uppercase
                                state={formState.errors?.prenomUsuel ? 'error' : null}
                                message={formState.errors?.prenomUsuel?.message}
                            />
                        </Col>
                    </Row>
                    <Row gutters verticalAlign="bottom">
                        <Col col={12} lg={6}>
                            <InputControl
                                autocomplete="bday"
                                id="dateNaissance"
                                label="Date de naissance *"
                                required
                                hintText="Exemple : 27/05/2001"
                                {...register('dateNaissance', {
                                    required: getMessageErreurChampManquant('Date de naissance'),
                                    pattern: getPatternHookFormValidation(
                                        REGEXP_DATE_AVEC_MOIS_JOUR_INCONNU,
                                        '',
                                        MESSAGE_DATE_INVALIDE,
                                    ),
                                    validate: {
                                        validateDate: (value) => validateDate(value),
                                        validateMajorite: (value) => validateMajorite(value),
                                    },
                                    onChange: () => {
                                        setValueRecherche('');
                                        setValue('lieuNaissance', '');
                                    },
                                })}
                                state={formState.errors?.dateNaissance ? 'error' : null}
                                message={formState.errors?.dateNaissance?.message}
                                maskFonction={getDateFormatWithSlash}
                            />
                        </Col>
                        <Col col={12} lg={6}>
                            <SelectPays
                                id="paysNaissance"
                                name="paysNaissance"
                                label="Pays de naissance *"
                                required
                                register={register('paysNaissance', {
                                    onChange: () => {
                                        setValueRecherche('');
                                        setValue('lieuNaissance', '');
                                    },
                                    required: getMessageErreurChampManquant('pays de Naissance'),
                                })}
                                placeholder="-- Choisir une option --"
                            />
                        </Col>
                    </Row>
                    <Row gutters verticalAlign="bottom">
                        <Col col={12} lg={6}>
                            <SelectDepartements
                                id="departementNaissance"
                                name="departementNaissance"
                                label="Département de naissance *"
                                required
                                register={register('departementNaissance', {
                                    validate: (value) => validateDepartement(value),
                                    onChange: () => {
                                        setValueRecherche('');
                                        setValue('lieuNaissance', '');
                                    },
                                })}
                                disabled={getValues('paysNaissance') !== '75'}
                                placeholder="-- Choisir une option --"
                            />
                        </Col>
                        <Col col={12} lg={6}>
                            <SelectCommune
                                name="communneNaissance"
                                label="Lieu de naissance"
                                valueRecherche={valueRecherche}
                                setValueRecherche={setValueRecherche}
                            />
                        </Col>
                    </Row>
                    <Row gutters verticalAlign="bottom">
                        <Col col={12} lg={6}>
                            <SelectPays
                                id="nationalite"
                                name="nationalite"
                                label="Nationalité *"
                                required
                                register={register('nationalite', {
                                    required: getMessageErreurChampManquant('nationalité'),
                                })}
                                placeholder="-- Choisir une option --"
                            />
                        </Col>
                        {motifs && !motifs.isNonLicencie && (
                            <Col col={12} lg={6}>
                                <InputControl
                                    id="numeroSia"
                                    label="Si vous possédez déjà un numéro SIA, veuillez le renseigner ci-dessous"
                                    uppercase
                                    {...register('numeroSia', {
                                        setValueAs: (v) => (v ? v.toUpperCase() : null),
                                    })}
                                />
                            </Col>
                        )}
                    </Row>
                    <Row gutters horizontalAlign="center" verticalAlign="bottom">
                        <Col col={12} lg={6}>
                            <div className="sia-input-alignementSansTexteAide">
                                <SelectControl
                                    id="typePieceIdentite"
                                    name="typePieceIdentite"
                                    label="Sélectionnez votre type de pièce d'identité *"
                                    options={formaterOptions(typePieceIdentite)}
                                    required
                                    {...register('typePieceIdentite', {
                                        required: getMessageErreurChampManquant(
                                            "type de pièce d'identité",
                                        ),
                                    })}
                                    placeholder="-- Choisir une option --"
                                />
                            </div>
                        </Col>
                        <Col col={12} lg={6}>
                            <InputControl
                                required
                                id="numeroPieceIdentite"
                                label="Numéro de la pièce d'identité *"
                                hintText="Le nombre de caractères de la pièce d'identité est limité à 50."
                                {...register('numeroPieceIdentite', {
                                    required: getMessageErreurChampManquant(
                                        "numéro de la pièce d'identité",
                                    ),
                                })}
                                state={formState.errors?.numeroPieceIdentite ? 'error' : null}
                                message={formState.errors?.numeroPieceIdentite?.message}
                                maxLength="50"
                            />
                        </Col>
                    </Row>
                    <Row gutters horizontalAlign="center" verticalAlign="bottom">
                        <Col col={12} lg={6}>
                            <InputControl
                                id="dateDelivrance"
                                label="Date de délivrance du document *"
                                required
                                hintText="Exemple : 01/02/1999"
                                {...register('dateDelivrance', {
                                    required: getMessageErreurChampManquant(
                                        'Date de délivrance du document',
                                    ),
                                    pattern: getPatternHookFormValidation(
                                        REGEXP_DATE_AVEC_MOIS_JOUR_INCONNU,
                                        '',
                                        MESSAGE_DATE_INVALIDE,
                                    ),
                                    validate: {
                                        validateDate: (value) => validateDate(value),
                                    },
                                })}
                                state={formState.errors?.dateDelivrance ? 'error' : null}
                                message={formState.errors?.dateDelivrance?.message}
                                maskFonction={getDateFormatWithSlash}
                            />
                        </Col>
                        <Col col={12} lg={6}>
                            <InputFiles
                                name="piecesIdentite"
                                label="Ajouter ma pièce d'identité"
                                error={formState.errors ? formState.errors.piecesIdentite : null}
                                required
                                multiple
                            />
                        </Col>
                    </Row>
                    <Row className="margin-top-lg">
                        <Col>
                            <ButtonGroup inline align="right">
                                <Button
                                    name="etapePrecedente"
                                    variant="secondary"
                                    type="button"
                                    isLoading={
                                        isLoading ||
                                        isLoadingRenseignerPiecesIdentite ||
                                        isLoadingPermisDeChasse ||
                                        isLoadingValidationPermisChasser ||
                                        isLoadingVersoLicenceSki ||
                                        isLoadingVersoLicenceBallTrap
                                    }
                                    onClick={retourEtape}
                                >
                                    Retour
                                </Button>
                                <Button
                                    name="etapeSuivante"
                                    variant="primary"
                                    type="submit"
                                    isLoading={
                                        isLoading ||
                                        isLoadingRenseignerPiecesIdentite ||
                                        isLoadingPermisDeChasse ||
                                        isLoadingValidationPermisChasser ||
                                        isLoadingVersoLicenceSki ||
                                        isLoadingVersoLicenceBallTrap
                                    }
                                    disabled={!hasFormValid()}
                                >
                                    Accéder à l'étape suivante
                                </Button>
                            </ButtonGroup>
                        </Col>
                    </Row>
                </form>
            </FormProvider>
        </SegmentLoader>
    );
};

CreerCompteIdentite.propTypes = {
    postApi: PropTypes.func.isRequired,
    reinitialiseApi: PropTypes.func.isRequired,
    isLoading: PropTypes.bool,
    erreur: PropTypes.bool,
    data: PropTypes.shape({
        uuidBrouillon: PropTypes.string.isRequired,
    }),
    message: PropTypes.string,
    isLoadingRenseignerPiecesIdentite: PropTypes.bool,
    erreurRenseignerPiecesIdentite: PropTypes.bool,
    dataRenseignerPiecesIdentite: PropTypes.string.isRequired,
    isLoadingPermisDeChasse: PropTypes.bool,
    erreurPermisDeChasse: PropTypes.bool,
    dataRenseignerPermisDeChasse: PropTypes.string.isRequired,
    isLoadingValidationPermisChasser: PropTypes.bool,
    erreurValidationPermisChasser: PropTypes.bool,
    dataRenseignerValidationPermisChasser: PropTypes.string.isRequired,
    erreurVersoLicenceSki: PropTypes.bool,
    isLoadingVersoLicenceSki: PropTypes.bool,
    dataRenseignerVersoLicenceSki: PropTypes.string.isRequired,
    erreurVersoLicenceBallTrap: PropTypes.bool,
    isLoadingVersoLicenceBallTrap: PropTypes.bool,
    dataRenseignerVersoLicenceBallTrap: PropTypes.string.isRequired,
    erreurVersoLicenceTir: PropTypes.bool,
    isLoadingVersoLicenceTir: PropTypes.bool,
    dataRenseignerVersoLicenceTir: PropTypes.string.isRequired,
    setEtapeIdentite: PropTypes.func.isRequired,
    setAncienLicencie: PropTypes.func.isRequired,
    dataIdentiteRenseignee: PropTypes.shape({
        dateNaissance: PropTypes.string,
        lieuNaissance: PropTypes.string,
        idNationalite: PropTypes.number,
        idPaysNaissance: PropTypes.number,
        idDepartementNaissance: PropTypes.number,
        nom: PropTypes.string,
        nomUsage: PropTypes.string,
        numeroPermisChasseur: PropTypes.string,
        numeroLicenceBallTrap: PropTypes.string,
        numeroLicenceSki: PropTypes.string,
        numeroLicenceTir: PropTypes.string,
        versoLicenceTir: PropTypes.instanceOf(FileUploadeAbstract),
        versoLicenceSki: PropTypes.instanceOf(FileUploadeAbstract),
        versoLicenceBallTrap: PropTypes.instanceOf(FileUploadeAbstract),
        selectLicencieOrAncienLicencieBallTrap: PropTypes.string,
        selectLicencieOrAncienLicencieSki: PropTypes.string,
        selectLicencieOrAncienLicencieTir: PropTypes.string,
        prenomUn: PropTypes.string,
        prenomDeux: PropTypes.string,
        prenomTrois: PropTypes.string,
        prenomQuatre: PropTypes.string,
        prenomUsuel: PropTypes.string,
        sexe: PropTypes.string,
        numeroPieceIdentite: PropTypes.string,
        typePieceIdentite: PropTypes.string,
        piecesIdentite: PropTypes.arrayOf(PropTypes.instanceOf(FileUploadeAbstract)),
        numeroGuichetUnique: PropTypes.instanceOf(FileUploadeAbstract),
        permisDeChasse: PropTypes.instanceOf(FileUploadeAbstract),
        validationPermisChasser: PropTypes.instanceOf(FileUploadeAbstract),
        numeroSia: PropTypes.string,
        dateDelivrance: PropTypes.string,
    }),
    uuidBrouillon: PropTypes.string,
    motifs: PropTypes.object.isRequired,
    retourEtape: PropTypes.func.isRequired,
    featureFlipping: PropTypes.object.isRequired,
};

export default connect(
    (state) => {
        const { isLoading, erreur, message, data } = state.compte.creer.renseignerIdentite;
        const {
            data: dataRenseignerPiecesIdentite,
            isLoading: isLoadingRenseignerPiecesIdentite,
            erreur: erreurRenseignerPiecesIdentite,
        } = state.compte.creer.renseignerPiecesIdentite;
        const {
            data: dataRenseignerPermisDeChasse,
            isLoading: isLoadingPermisDeChasse,
            erreur: erreurPermisDeChasse,
        } = state.compte.creer.renseignerPermisDeChasse;
        const {
            data: dataRenseignerValidationPermisChasser,
            isLoading: isLoadingValidationPermisChasser,
            erreur: erreurValidationPermisChasser,
        } = state.compte.creer.renseignerValidationPermisChasser;
        const {
            data: dataRenseignerVersoLicenceSki,
            isLoading: isLoadingVersoLicenceSki,
            erreur: erreurVersoLicenceSki,
        } = state.compte.creer.renseignerVersoLicenceSki;
        const {
            data: dataRenseignerVersoLicenceBallTrap,
            isLoading: isLoadingVersoLicenceBallTrap,
            erreur: erreurVersoLicenceBallTrap,
        } = state.compte.creer.renseignerVersoLicenceBallTrap;
        const {
            data: dataRenseignerVersoLicenceTir,
            isLoading: isLoadingVersoLicenceTir,
            erreur: erreurVersoLicenceTir,
        } = state.compte.creer.renseignerVersoLicenceTir;

        return {
            isLoading,
            erreur,
            data,
            message,
            dataRenseignerPiecesIdentite,
            isLoadingRenseignerPiecesIdentite,
            erreurRenseignerPiecesIdentite,
            dataRenseignerPermisDeChasse,
            isLoadingPermisDeChasse,
            erreurPermisDeChasse,
            dataRenseignerValidationPermisChasser,
            isLoadingValidationPermisChasser,
            erreurValidationPermisChasser,
            dataRenseignerVersoLicenceSki,
            isLoadingVersoLicenceSki,
            erreurVersoLicenceSki,
            dataRenseignerVersoLicenceBallTrap,
            isLoadingVersoLicenceBallTrap,
            erreurVersoLicenceBallTrap,
            dataRenseignerVersoLicenceTir,
            isLoadingVersoLicenceTir,
            erreurVersoLicenceTir,
        };
    },
    {
        postApi: postAPI,
        reinitialiseApi: reinitialiseAPI,
    },
)(CreerCompteIdentite);
